'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateAccountDetails = exports.getUiUpdateAccount = exports.UPDATE_ACCOUNT_SUCCESS = exports.UPDATE_ACCOUNT_REQUEST = exports.UPDATE_ACCOUNT_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _user = require('./user');

var _api = require('../api');

var _reselect = require('reselect');

var _config = require('../modules/config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {
//     getAttributionData,
//     getEditProfileAnalytics,
// } from '../selectors';

/* Action Types */
var UPDATE_ACCOUNT_FAIL = exports.UPDATE_ACCOUNT_FAIL = 'la/ui/updateAccount/FAIL';
var UPDATE_ACCOUNT_REQUEST = exports.UPDATE_ACCOUNT_REQUEST = 'la/ui/updateAccount/REQUEST';
var UPDATE_ACCOUNT_SUCCESS = exports.UPDATE_ACCOUNT_SUCCESS = 'la/ui/updateAccount/SUCCESS';

/* reducer */
var DEFAULT_STATE = {
    error: false,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case UPDATE_ACCOUNT_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        case UPDATE_ACCOUNT_REQUEST:
            return (0, _extends3.default)({}, state, {
                submitted: true,
                success: false
            });
        case UPDATE_ACCOUNT_SUCCESS:
            return (0, _extends3.default)({}, state, {
                error: false,
                submitted: false,
                success: true
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.updateAccount;
};

var getUiUpdateAccount = exports.getUiUpdateAccount = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var updateAccountDetails = exports.updateAccountDetails = function updateAccountDetails(userDetails) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, userData, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            userData = (0, _user.getUserData)(state);

                            userDetails.username = userData.username;
                            dispatch({
                                type: UPDATE_ACCOUNT_REQUEST
                            });
                            _context.next = 9;
                            return _api.Bidder.postCompleteAccount({
                                authToken: authToken,
                                bidderDetails: userDetails,
                                deployment: deployment
                            });

                        case 9:
                            response = _context.sent;

                            dispatch({
                                // meta: { ...getEditProfileAnalytics(attributionData), actionTime: Date.now() },
                                meta: { actionTime: Date.now() },
                                payload: response,
                                type: UPDATE_ACCOUNT_SUCCESS
                            });
                            _context.next = 16;
                            break;

                        case 13:
                            _context.prev = 13;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: UPDATE_ACCOUNT_FAIL
                            });

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 13]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/updateAccount.js
// module id = A6XQ
// module chunks = 46